module.exports = "export default __webpack_public_path__ + &quot;e7ee92939e597142561043fbc46f8e55.svg&quot;;"